import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import green from '@material-ui/core/colors/green'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import SearchIcon from "@material-ui/icons/Search"
import ErrorIcon from "@material-ui/icons/Error"
import CloudDoneIcon from "@material-ui/icons/CloudDone"
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import axios from 'axios';
import {bffUrl} from './config.js';
import MUIDataTable from "mui-datatables";
import CircularProgress from '@material-ui/core/CircularProgress';
import {withSnackbar} from 'notistack';
import qs from "qs";
import Tooltip from '@material-ui/core/Tooltip'
import HourGlassEmptyIcon from '@material-ui/icons/HourglassEmptyRounded'
import {DateTime} from "luxon";
import UserService from "./Services/UserService";
import {givePrivileges} from "./actions/privilegeActions";
import {connect} from "react-redux";
import {getSupportUsers} from "./actions/supportUserActions";

const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    container: {
        position: 'relative',
    },
    card: {
        minWidth: 75,
        backgroundColor: "#DCDCDC",
        marginTop: "10px"
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)",
    },
    title: {
        fontSize: 20,
        color: "#FF0000",
        textAlign: "center"
    },
    pos: {
        marginBottom: 12
    }
};

class TranscodingStatusContainer extends Component {

    state = {
        cid: this.cid,
        transcodingStatusResponse: [],
        showLoading: false,
        multipleCidtranscodingStatusResponse: [],
        failureTrancodingCids: "",
        supportUsers:[]
    };

    constructor(props) {
        super(props);
        let parsed = qs.parse(this.props.location.search);

        if (parsed["?cids"] && parsed["?cids"].length > 0) {
            this.state.cid = parsed["?cids"];
        } else {
            this.state.cid = "";
        }
    }


    ifSupportUser = async (email) => {
        let supportUsers = this.state.supportUsers;

        return (supportUsers.includes(email));
    };

    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    componentDidMount() {

        this.getTranscodingStatusForCid();

    }

    getTranscodingStatusForCid = event => {

        let self = this;
        if (this.state.cid !== "") {
            const {cid} = this.state;
            var cids = cid.split(",");
            cids = cids.map(s => s.trim());

            if (Object.keys(cids).length > 10) {
                alert("Enter Maximum 10 cids");
                this.setState({
                    cid: ''
                });
                return false;
            }

            this.setState({
                showLoading: true,
                transcodingStatusResponse: [],
                multipleCidtranscodingStatusResponse: [],
                failureTrancodingCids: ""
            });


            var userName = sessionStorage.getItem("userName");

            var getTranscodingStatusUrl = `${bffUrl}/video/getStatusOfAllJobCode?cid=${cid}&username=${userName}`;

            const getTranscodingStatusInstance = axios.create({
                baseURL: getTranscodingStatusUrl,
                timeout: 150000
            });


            getTranscodingStatusInstance.get()
                .then(res => {

                    let supportUserFlag = true;
                   // if(self.props.supportUsers && self.props.supportUsers.length>0){
                        //supportUserFlag = self.props.supportUsers.includes(sessionStorage.userEmail);
                  //  }

                    console.log({supportUserFlag});
                    if (res.data) {

                        var tempMultipleCidResponse = [];

                        if (Object.keys(res.data).length > 0) {


                            res.data.map(jobCodeResponseForSingleCid => {

                                var finalResponse = [];
                                if (Object.keys(jobCodeResponseForSingleCid).length > 0) {
                                    // when return data
                                    jobCodeResponseForSingleCid.map(jobCodeResponse => {


                                        if ( (supportUserFlag) ||
                                            (jobCodeResponse.jobCode !== "GMN" && jobCodeResponse.jobCode !== "UST_VP6" && jobCodeResponse.jobCode !== "UST_VP9" && jobCodeResponse.jobCode !== "NP12")
                                        ) {
                                            var currentResponse = [];

                                            if (jobCodeResponse.cid) {
                                                currentResponse.push(jobCodeResponse.cid);
                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.jobCode) {
                                                currentResponse.push(jobCodeResponse.jobCode);

                                                if (jobCodeResponse.jobCode === "VP6") {
                                                    currentResponse.push("Browser, iOS, Android-Basic");
                                                }

                                                if (jobCodeResponse.jobCode === "VP9") {
                                                    currentResponse.push("Android-Optimized");
                                                }

                                                if (jobCodeResponse.jobCode === "NP6320") {
                                                    currentResponse.push("Mass Market");
                                                }
                                                if (jobCodeResponse.jobCode === "NP12") {
                                                    currentResponse.push("Mass Market");
                                                }
                                                if (jobCodeResponse.jobCode === "GMN") {
                                                    currentResponse.push("Autograb");
                                                }
                                                if (jobCodeResponse.jobCode === "UST_VP6") {
                                                    currentResponse.push("Subtitle-VP6");
                                                }
                                                if (jobCodeResponse.jobCode === "UST_VP9") {
                                                    currentResponse.push("Subtitle-VP9");
                                                }

                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.transcodingStatus) {
                                                currentResponse.push(jobCodeResponse.transcodingStatus);
                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.transcodingPercentage) {
                                                currentResponse.push(jobCodeResponse.transcodingPercentage);
                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.transcodingState) {
                                                currentResponse.push(jobCodeResponse.transcodingState);
                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.statusCode) {
                                                currentResponse.push(jobCodeResponse.statusCode);
                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.taskMessage) {
                                                currentResponse.push(jobCodeResponse.taskMessage);
                                            } else {
                                                currentResponse.push("");
                                            }

                                            if (jobCodeResponse.updated) {
                                                currentResponse.push(DateTime.fromFormat(jobCodeResponse.updated, "dd-MM-yyyy HH:mm:ss").toLocaleString(DateTime.DATETIME_MED));
                                            } else {
                                                currentResponse.push("");
                                            }
                                            finalResponse.push(currentResponse);
                                        }else{

                                        }
                                    });
                                    var retVal = 0;
                                    finalResponse = finalResponse.sort(function (a, b) {
                                        retVal = 0;
                                        if (a[0] !== b[0]) retVal = a[0] < b[0] ? 1 : -1;
                                        else if (a[1] !== b[1]) retVal = a[1] < b[1] ? 1 : -1;
                                        else if (a[2] !== b[2]) retVal = a[2] < b[2] ? 1 : -1;
                                        else if (a[3] !== b[3]) retVal = a[3] < b[3] ? 1 : -1;
                                        else if (a[4] !== b[4]) retVal = a[4] < b[4] ? 1 : -1;
                                        else if (a[5] !== b[5]) retVal = a[5] < b[5] ? 1 : -1;
                                        return retVal;
                                    });

                                    let newFinalResponse = [];

                                    if (finalResponse.length > 2) {
                                        newFinalResponse.push(finalResponse[1]);
                                        newFinalResponse.push(finalResponse[0]);
                                        newFinalResponse.push(finalResponse[2]);
                                    } else {
                                        newFinalResponse = finalResponse;
                                    }

                                    if(finalResponse.length>3){
                                        newFinalResponse.push(finalResponse[3]);
                                    }
                                    if(finalResponse.length>4){
                                        newFinalResponse.push(finalResponse[4]);
                                    }
                                    if(finalResponse.length>5){
                                        newFinalResponse.push(finalResponse[5]);
                                    }

                                    var index = cids.indexOf(newFinalResponse[0][0].toString().trim());

                                    if (index > -1) {
                                        cids.splice(index, 1);
                                    }

                                    tempMultipleCidResponse.push(newFinalResponse)
                                } else {
                                    // when return empty response
                                    tempMultipleCidResponse.push(finalResponse)
                                }
                            });

                            var stringOfFailureCids = cids.join(",");
                            if (Object.keys(tempMultipleCidResponse).length > 0) {
                                this.setState({
                                    multipleCidtranscodingStatusResponse: tempMultipleCidResponse,
                                    showLoading: false,
                                    failureTrancodingCids: stringOfFailureCids
                                }, () => {
                                })
                            } else {
                                this.props.enqueueSnackbar('Failure.', {
                                    variant: 'warning', anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }
                                });

                                this.setState({
                                    cid: '',
                                    transcodingStatusResponse: [],
                                    showLoading: false
                                })
                            }
                        } else {
                            this.props.enqueueSnackbar('Data Does not Exist.', {
                                variant: 'warning', anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }
                            });

                            this.setState({
                                cid: '',
                                transcodingStatusResponse: [],
                                showLoading: false
                            })

                        }
                    } else {
                        this.props.enqueueSnackbar('Data Does not Exist.', {
                            variant: 'warning', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });

                        this.setState({
                            cid: '',
                            transcodingStatusResponse: [],
                            showLoading: false
                        })
                    }
                }, () => {
                    console.log("Failed to Load")
                })
                .catch(err => {
                    this.props.enqueueSnackbar('Failed to load Status.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });

                    this.setState({
                        cid: '',
                        transcodingStatusResponse: [],
                        showLoading: false
                    })
                })
        }


    };

    render() {
        const columns = [
            {
                name: "Cid",
                options: {
                    display: 'false',
                }
            },
            {
                name: "Jobcode",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        if (value === "VP6") {
                            return <React.Fragment>
                                <b>VP6</b>
                            </React.Fragment>
                        } else {
                            return value
                        }
                    }
                }
            },
            {
                name: "Platform",
            },
            {
                name: "Status",
                options: {
                    customBodyRender: (value, tableMeta, updateValue) => {

                        let element = null;

                        if (value === "SUCCESS") {
                            element = <CloudDoneIcon style={{color: 'green'}}/>
                        }
                        if (value === "ERROR") {
                            element = <ErrorIcon style={{color: 'red'}}/>
                        }
                        if (value === "RUNNING") {
                            element = <HourGlassEmptyIcon style={{color: 'orange'}}/>
                        }
                        if (element) {
                            return (

                                <React.Fragment>
                                    <Tooltip title={value} aria-label={value}>
                                        {element}
                                    </Tooltip>

                                </React.Fragment>
                            );
                        } else {
                            return (

                                <React.Fragment>
                                    <Typography variant={"caption"}>
                                        {value}
                                    </Typography>

                                </React.Fragment>
                            );
                        }


                    }
                }
            },
            {
                name: "Percentage"
            },
            {
                name: "Transcoding State"
            },
            {
                name: "Status Code",
                options: {}
            },
            {
                name: "Task Message",
                options: {}
            },
            {
                name: "Update time in " + Intl.DateTimeFormat().resolvedOptions().timeZone
            }

        ];

        const options = {
            filterType: 'dropdown',
            pagination: false,
            selectableRows: 'none',
            print: false,
            download: false,
            responsive: 'scrollFullHeight',
            viewColumns: false,
            expandableRows: false,
            filter: false,
            search: false,

        };

        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};

        const buttonIconStyle = {
            // marginLeft: '1em'
        };

        const checkButtonStyle = {
            marginLeft: '1em'
        };

        const containerStyle = {
            minHeight: '650px'
        };

        const contentIdInputStyle = {};

        return (
            <div className={classes.root}>

                <Paper style={containerStyle}>
                    <br/>

                    <Grid container spacing={1}
                          direction="row"
                          justify="flex-start"
                          alignContent="flex-start"
                    >

                        <Grid item sm={3}></Grid>
                        <Grid item sm={3}>
                            <TextField style={contentIdInputStyle} fullWidth
                                       multiline
                                       rowsMax="6"
                                       rows="3"
                                       variant="outlined"
                                       label="Enter Content IDs"
                                       value={this.state.cid}
                                       onChange={this.handleChange('cid')}
                            />
                        </Grid>


                        {
                            this.state.cid.trim() === '' ?

                                <Grid item sm={2} style={{paddingTop: '10px'}}>
                                    <Button variant="contained" style={checkButtonStyle} color="primary" disabled>
                                        <SearchIcon style={buttonIconStyle}/>
                                        Check Status
                                    </Button>
                                </Grid>
                                :
                                <Grid item sm={2} style={{paddingTop: '10px'}}>
                                    <Button variant="contained" style={checkButtonStyle} color="primary"
                                            onClick={this.getTranscodingStatusForCid.bind(this)}>
                                        <SearchIcon style={buttonIconStyle}/>
                                        Check Status
                                    </Button>
                                </Grid>
                        }


                    </Grid>
                    <br/>


                    {
                        this.state.multipleCidtranscodingStatusResponse && Object.keys(this.state.multipleCidtranscodingStatusResponse).length > 0
                            ?
                            this.state.multipleCidtranscodingStatusResponse.map((transcodingStatusForSingleCid, index) =>
                                <React.Fragment key={index}>
                                    {
                                        transcodingStatusForSingleCid && Object.keys(transcodingStatusForSingleCid).length > 0
                                            ?
                                            <Grid container spacing={0}
                                                  direction="row"
                                                  justify="space-around"
                                                  alignItems="center">

                                                <Grid item sm={12}>

                                                    <MUIDataTable
                                                        title={`Transcoding Status for ${transcodingStatusForSingleCid[0][0]}`}
                                                        data={transcodingStatusForSingleCid}
                                                        columns={columns}
                                                        options={options}
                                                    />
                                                    <br></br>

                                                </Grid>
                                            </Grid>
                                            :
                                            null
                                    }
                                </React.Fragment>
                            )
                            :
                            null
                    }
                    {
                        this.state.failureTrancodingCids && Object.keys(this.state.failureTrancodingCids).length > 0
                            ?
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography
                                        className={classes.title}
                                        color="textSecondary"
                                        gutterBottom
                                    >
                                        {`No Response Available For Cids  : ${this.state.failureTrancodingCids}`}
                                    </Typography>
                                </CardContent>
                            </Card>
                            :
                            null
                    }


                    {
                        this.state.showLoading
                            ?
                            <div style={{textAlign: 'center'}}>
                                <CircularProgress className={classes.progress} color="secondary"/>
                            </div>
                            : null
                    }

                </Paper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        supportUsers: state.supportUser.supportUsers
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSupportUsers: () => dispatch(getSupportUsers())
    }
};

const TranscodingStatusContainerComponent = withSnackbar(TranscodingStatusContainer);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TranscodingStatusContainerComponent));